import { Button, DatePicker, Drawer, Form, Modal } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { authenticateToken } from "../../../utils/auth";
import moment from "moment";
import Loading from "../../common/Loader";
import Empty from "../../common/Empty";
import PaginationTwo from "../../common/PaginationTwo";
import { getPage, getParamValue } from "../../../utils";
import { useLocation } from "react-router";
import AddHistory from "./AddHistory";
import TopHeading from "../TopHeading";
import SingleHistory from "./Details";
const { RangePicker } = DatePicker;

const VrHistoryList = () => {
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [limit, setLimit] = useState(16);
  const [visibleModal, setVisibleModal] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [selectedHistory, setSelectedHistory] = useState(undefined);
  const [selectedHistoryForEdit, setSelectedHistoryForEdit] =
    useState(undefined);

  const [vrHistoryData, setVrHistoryData] = useState({
    loading: false,
    data: null,
  });

  const [vrData, setVrData] = useState({
    loading: false,
    data: null,
  });

  const [range, setRange] = useState({
    from: null,
    to: null,
  });

  const getVrHistory = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setVrHistoryData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_TOPUP_API}`;
    axios
      .get(
        `${encodedUri}/admin/topup/vr-history?page=${page || 0}&limit=${
          limit || 16
        }` +
          (from ? `&from=${from}` : ``) +
          (to ? `&to=${to}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setVrHistoryData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setVrHistoryData({ loading: false, data: [] });
        console.error("Hub: Error", err);
      });
  }, [page, limit, range.from, range.to]);

  const getVRBalance = useCallback(async () => {
    setVrData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_TOPUP_API}`;
    axios
      .get(`${encodedUri}/admin/topup/vr-balance`, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      })
      .then((res) => {
        setVrData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setVrData({ loading: false, data: [] });
        console.error("Promo: Error", err);
      });
  }, []);

  useEffect(() => {
    getVrHistory();
  }, [getVrHistory]);

  useEffect(() => {
    if (visibleModal) {
      getVRBalance();
    }
  }, [getVRBalance, visibleModal]);

  const reseAllFieldData = () => {
    form.resetFields();
    setRange({
      from: null,
      to: null,
    });
  };

  const showModal = () => {
    setVisibleModal(true);
  };

  const handleOk = () => {
    setVisibleModal(undefined);
  };

  const handleCancel = () => {
    setVisibleModal(undefined);
  };
  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setSelectedHistory(null);
    setSelectedHistoryForEdit(null);
    setVisible(undefined);
    getVrHistory();
  };

  console.log("Total :", vrHistoryData?.data?.totalElements);
  return (
    <React.Fragment>
      <TopHeading
        title="VR History"
        total={vrHistoryData?.data?.totalElements || 0}
        refetch={getVrHistory}
        extra={
          <div>
            <Button
              type="dashed"
              shape="round"
              onClick={showModal}
              className="mr-2"
            >
              Balance
            </Button>
            <Button type="dashed" shape="round" danger onClick={showDrawer}>
              Add History
            </Button>
          </div>
        }
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          <RangePicker
            defaultValue={
              range.from != null && range.to != null
                ? [moment(range.from), moment(range.to)]
                : null
            }
            onChange={(e, f) => {
              setRange({ from: f?.[0], to: f?.[1] });
            }}
            showTime={{
              hideDisabledOptions: true,
              defaultValue: [
                moment("00:00:00", "HH:mm:ss"),
                moment("23:59:59", "HH:mm:ss"),
              ],
            }}
            inputReadOnly
            allowClear
          />
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  {/* <div className="single-product-heading">
                    <span>Image</span>
                  </div> */}
                  <div className="single-product-heading">
                    <span>Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Payment Method</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Amount</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {vrHistoryData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {vrHistoryData?.data?.history?.length ? (
                    vrHistoryData?.data?.history?.map(
                      (data: any, index: any) => (
                        <React.Fragment key={index}>
                          <div
                            className="single-product-wrapper"
                            onClick={() => setSelectedHistory(data)}
                          >
                            {/* <div className="single-product">
                              <span className="name">
                                <Avatar src={data?.imageUrl} size={50} />
                              </span>
                            </div> */}
                            <div className="single-product">
                              <span className="name">
                                {moment(data?.createdAt)?.format("lll")}
                              </span>
                            </div>

                            {/* <div className="single-product">
                              <span className="name">
                                {data?.createdBy?.name && data?.createdBy?.name}
                                {data?.createdBy?.mobileNumber}
                              </span>
                            </div> */}

                            <div className="single-product">
                              <span className="name">
                                {data?.paymentMethod}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                &#2547;{data?.amount}
                              </span>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="History" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Modal
            title="VR BALANCE"
            visible={visibleModal}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Got It !"
          >
            <div className="text-center text-uppercase">
              <p>Client: {vrData?.data?.balance?.clientId}</p>
              <p>
                Available Credit: &#2547;
                {vrData?.data?.balance?.availableCredit}
              </p>
              <p>
                Updated Date:{" "}
                {moment(vrData?.data?.balance?.lastUpdatedTime).format("lll")}
              </p>
            </div>
          </Modal>

          <Drawer
            title={
              selectedHistoryForEdit || visible
                ? "Add/Edit History"
                : "VR Details"
            }
            width={500}
            onClose={onClose}
            visible={selectedHistory || selectedHistoryForEdit || visible}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedHistoryForEdit || visible ? (
              <AddHistory
                visibleData={selectedHistoryForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <SingleHistory HistoryDetails={selectedHistory} />
            )}
          </Drawer>

          <PaginationTwo
            {...vrHistoryData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default VrHistoryList;
